import { render } from "./_video.vue?vue&type=template&id=e4a66f68"
import script from "./_video.vue?vue&type=script&lang=js"
export * from "./_video.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__